import { getTableColumns } from 'helpers';

const PartCountriesColumns = [
  ['name', 'string', 'Country Name', 'center', true],
  ['code', 'string', 'Country Abbreviation', 'center', true],
  ['participationDate', 'date', 'Start Date', 'center', true],
  ['participationEndDate', 'date', 'End Date', 'center', true],
  ['regulatoryRqmt', 'string', 'Regulatory Requirement', 'left', true],
  ['regulatoryHolder', 'string', 'Regulatory Holder', 'left', true]
];


export default getTableColumns(PartCountriesColumns);
